export const seeMoreDestinations = {
  analystRatings: (symbol: string): string => `/analyst-stock-ratings?tickers=${encodeURIComponent(symbol)}`,
  dividends: (symbol: string): string => `/dividends?date_sort=ex&tickers=${encodeURIComponent(symbol)}`,
  events: (symbol: string): string => `/calendars/events?tickers=${encodeURIComponent(symbol)}`,
  governmentTrades: (symbol: string): string => `/government-trades/securities/${encodeURIComponent(symbol)}`,
  insiderTrades: (symbol: string, companyName?: string, cik?: string): string => {
    const key = cik
      ? `company_cik=${encodeURIComponent(cik.padStart(10, '0'))}`
      : `company_ticker=${encodeURIComponent(symbol)}`;
    const base = `/sec/insider-trades/search?${key}`;
    return companyName ? `${base}&search_title=${encodeURIComponent(companyName)}` : base;
  },
  shortInterest: (symbol: string): string => `/calendars/short-interest?tickers=${encodeURIComponent(symbol)}`,
  unusualOptions: (symbol: string): string =>
    `/calendars/unusual-options-activity?tickers=${encodeURIComponent(symbol)}`,
};
